import {
  Info,
  AlertTriangle,
  Lightbulb,
  CheckCircle2,
  AlertOctagon,
  MessageSquare,
} from "lucide-react";

export const CALLOUT_STYLES = {
  note: { accent: "#3B82F6", bg: "#EFF6FF", icon: Info, label: "Note" },
  tip: { accent: "#22C55E", bg: "#F0FDF4", icon: Lightbulb, label: "Tip" },
  success: {
    accent: "#22C55E",
    bg: "#F0FDF4",
    icon: CheckCircle2,
    label: "Done",
  },
  warning: {
    accent: "#F59E0B",
    bg: "#FFFBEB",
    icon: AlertTriangle,
    label: "Warning",
  },
  danger: {
    accent: "#EF4444",
    bg: "#FEF2F2",
    icon: AlertOctagon,
    label: "Danger",
  },
  neutral: {
    accent: "#6B7280",
    bg: "#F9FAFB",
    icon: MessageSquare,
    label: "Note",
  },
};

export default function Callout({ type = "note", children }) {
  const style = CALLOUT_STYLES[type] || CALLOUT_STYLES.note;
  const Icon = style.icon;
  return (
    <div
      className="flex gap-3 rounded-[10px] px-4 py-3.5 my-4 border-l-4"
      style={{ backgroundColor: style.bg, borderLeftColor: style.accent }}
    >
      <Icon
        className="w-4 h-4 flex-shrink-0 mt-0.5"
        style={{ color: style.accent }}
      />
      <p className="text-[14px] geist-regular text-[#374151] leading-relaxed">
        <span className="geist-medium" style={{ color: style.accent }}>
          {style.label}:
        </span>{" "}
        {children}
      </p>
    </div>
  );
}
